import QRCode from "qrcode";
import { useEffect, useState } from "react";

export interface QrCodeProps {
	value: string;
	/** Described to screen readers, which cannot read the image. */
	label: string;
	size?: number;
}

export function QrCode({ value, label, size = 192 }: QrCodeProps) {
	const [dataUrl, setDataUrl] = useState<string | null>(null);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		let active = true;
		setFailed(false);

		QRCode.toDataURL(value, { errorCorrectionLevel: "M", margin: 1, width: size * 2 })
			.then((url) => {
				if (active) setDataUrl(url);
			})
			.catch(() => {
				if (active) setFailed(true);
			});

		return () => {
			active = false;
		};
	}, [value, size]);

	if (failed) {
		return (
			<p className="text-sm text-(--text-secondary)">
				We could not draw the QR code. Enter the setup key below into your authenticator app instead.
			</p>
		);
	}

	return (
		<div
			className="inline-flex items-center justify-center rounded-(--radius-md) border border-(--border-subtle) bg-white p-3"
			style={{ width: size + 24, height: size + 24 }}
		>
			{dataUrl ? (
				<img src={dataUrl} alt={label} width={size} height={size} />
			) : (
				<span className="sr-only">Preparing QR code</span>
			)}
		</div>
	);
}
